module.exports = __webpack_public_path__ + "img/文本cos.22dcdae2.png";